import { useContext, useEffect, useState } from 'react';

import UserContext from '../../store/user-context';
import { LANGUAGES } from '../../App.js';
import useFetch from '../../hooks/use-fetch';
import AlertModal from '../../components/UI/Modal/AlertModal';
import { PrimaryButton, DeleteButton } from '../../components/UI/Button';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import {useTranslation} from 'react-i18next';
import Slider from './Slider';
import { getLangCode } from '../Helpers/Util/User';

const LanguageSelector = ({langType = 'learning'}) => {
  const {t: translate, i18n } = useTranslation();
  // const userContext = useContext(UserContext);
  const { user, setUser } = useContext(UserContext);
  const { data, initFunc: updateData } = useFetch();
  const { apiUrl } = window['appConfig'];
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [activeLang, setActiveLang] = useState(user.user[langType]);
  const [cards, setCards] = useState([]);
  const langPhrase = langType === 'learning' ? translate('learning-language') : translate('native-language')
  const [activeIndex, setActiveIndex] = useState(0);

  const languages = () => {
    const selectLangs = LANGUAGES.map((language, index) => {
      if (language.name === activeLang) {
          setActiveIndex(index);
        return {...language, active: true};
      } else {
        return {...language, active: false};
      }
    });

    setCards(selectLangs);
  };

  const changeUserLanguage = async () => {
    let fetchData = new URLSearchParams();
    fetchData.append(`${langType}`, activeLang);
    
    const fetchOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: fetchData,
    };

    const progressUrl = `${apiUrl}/user`;

    updateData({ url: progressUrl, options: fetchOptions });
    setShowAlertModal(false);
    //Update DB
    // await updateUserLanguage(langName);

    //Update Context
    // setUser(prevState => ({
    //     ...prevState,
    //     user: {                   // object that we want to update
    //         ...prevState.user,    // keep all other key-value pairs
    //         learning: langName       // update the value of specific key
    //     }
    // }));

    // //Update LANGUAGES const
    // languages();
  };
  // const initialLang =
  //   cards?.filter((card) => card.active === true)[0]?.name ?? '';
  // const [languageChosen, setLanguageChosen] = useState(initialLang);

  const setLanguageInfo = (e) => {
    let langName = e.target.getAttribute('data-name');
    // let prettyName = langName.charAt(0).toUpperCase() + langName.slice(1);
    let prettyName = translate(langName)
    setAlertMessage(translate('change-lang-message',{langPhrase: langPhrase, prettyName: prettyName}));
    setActiveLang(langName);
    setShowAlertModal(true);
    // setLanguageChosen(e.target.value);
  };

  // const cardHandler = async (e) => {
  //   let langName = e.target.getAttribute('data-name');
  //   let prettyName = langName.charAt(0).toUpperCase() + langName.slice(1);
  //   let changeLang = window.confirm(
  //     `Change learning language to ${prettyName}?`,
  //   );

  //   console.log('confirm: ' + changeLang);
  //   if (changeLang === true) {
  //     dispatch({
  //       type: ACTIONS.TOGGLE_CARD,
  //       payload: { name: langName, user: user },
  //     });

  //     let fetchData = new URLSearchParams();
  //     fetchData.append('learning', langName);

  //     const fetchOptions = {
  //       method: 'PUT',
  //       headers: {
  //         'Content-Type': 'application/x-www-form-urlencoded',
  //       },
  //       body: fetchData,
  //     };

  //     const progressUrl = `${process.env.REACT_APP_BASE_URL}/user`;

  //     updateData({ url: progressUrl, options: fetchOptions });

  //     //Update DB
  //     // await updateUserLanguage(langName);

  //     //Update Context
  //     // setUser(prevState => ({
  //     //     ...prevState,
  //     //     user: {                   // object that we want to update
  //     //         ...prevState.user,    // keep all other key-value pairs
  //     //         learning: langName       // update the value of specific key
  //     //     }
  //     // }));

  //     // //Update LANGUAGES const
  //     // languages();
  //   }
  // };

  // const updateUserLanguage = async (langName) => {
  //     const jwtToken = {};
  //     jwtToken.Authorization = `Bearer ${user.jwtToken}`

  //     const formData = new URLSearchParams();
  //     formData.append('learning', langName);
  //     // formData.append('language', 'british');

  //     const response = await fetch(`${apiUrl}/user`, {
  //         method: 'PUT',
  //         headers : {
  //             'Content-Type': 'application/x-www-form-urlencoded',
  //             ...jwtToken
  //           },
  //         body: formData
  //     })

  //     if (!response.ok) {
  //         const message = `An error has occured: ${response.status}`;
  //         throw new Error(message);
  //     }

  //     return response
  // }

  useEffect(() => {
    languages()
  },[])

  useEffect(() => {
    if (data !== null) {
      // Update Context
      setUser((prevState) => ({
        ...prevState,
        user: {
          // object that we want to update
          ...prevState.user, // keep all other key-value pairs
          [langType]: data[langType], // update the value of specific key
        },
      }));

      if( langType !== 'learning' ) {
        i18n.changeLanguage(getLangCode(data[langType]));
      }

      //Update LANGUAGES const
      languages();
    }
  }, [data]);

  return (
    <div className="available-languages">
      <Slider starting_index={activeIndex}>
        {cards.map((lang, index) => {
          let image = `/flags/${lang.name}.png`;
          let langClass = 'language';

          if (lang.active === true) {
            langClass = 'language language--active';
          }

          if (lang.enabled !== true) {
            langClass = 'language language--disabled';
          }

          return (
            <div
              className={langClass}
              key={`${lang.name}_${index}`}
              data-name={lang.name}
              onClick={(e) => {setLanguageInfo(e), setActiveIndex(index);}}
            >
              <img src={image} alt={lang.name} className="language__image" />
              <h6 className="language__title">{translate(lang.name)}</h6>
            </div>
          );
        })}
      </Slider>
      <AlertModal
        isOpen={showAlertModal}
        handleClose={() => setShowAlertModal(false)}
        title={translate('change-language')}
        message={alertMessage}
        closeMessage="Cancel"
        icon={<GppMaybeIcon style={{ transform: 'scale(2)' }} />}
        closeButtonType={DeleteButton}
        additionalButton={
          <PrimaryButton
            size="small"
            style={{
              width: '100%',
              marginTop: '10px',
              background: '#00a680',
            }}
            onClick={() => {
              changeUserLanguage();
            }}
          >
            {translate('confirm')}
          </PrimaryButton>
        }
      />
    </div>
  );
};

export default LanguageSelector;
